export const bazaarCheck = path => !!(path.match('/tires') || path.match('/global-search'))
